import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	x: "0px",
	y: "0px",
	viewBox: "0 0 20 20",
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		id: "style1",
		children: "\n	.clock-icon{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsxs("g", {
		id: "g3",
		transform: "translate(-2,-2)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "clock-icon",
				d: "m 12,21 c 4.9706,0 9,-4.0294 9,-9 0,-4.97056 -4.0294,-9 -9,-9 -4.97056,0 -9,4.02944 -9,9 0,4.9706 4.02944,9 9,9 z",
				id: "path1"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "clock-icon",
				d: "m 12,12 h 5.25",
				id: "path2"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "clock-icon",
				d: "M 15.7123,15.7123 12,12",
				id: "path3"
			})
		]
	})]
});
export default SvgClockIcon;
